import { useState } from 'react'

import { MonthResponse } from 'core/application/benefit/getAnnualAttestationDetails'

import { Button, Icon } from 'common/components'

type CoverageAttestationCalendarButtonProps = {
  month: MonthResponse
  onClick?: (month: MonthResponse) => void
}

const CoverageAttestationCalendarButton = ({ month, onClick = () => {} }: CoverageAttestationCalendarButtonProps) => {
  const [showEditIcon, setShowEditIcon] = useState(false)

  const showIcon = (month: MonthResponse) => {
    if (month.ineligible) {
      return <Icon type="fas fa-ban" />
    } else if (!month.isAttestationDecisionMade) {
      return <Icon type="fas fa-exclamation-triangle" className="color-yellow-7" />
    } else if (month.isAttestationDecisionMade && month.attested) {
      return <Icon type="fas fa-check-circle" className="color-green-7" />
    } else if (month.isAttestationDecisionMade && !month.attested) {
      return <Icon type="fas fa-ban" className={'color-red-6'} />
    }
    return null
  }

  const isDisabled = month.ineligible || month.isFutureMonth

  const canEdit = !isDisabled && showEditIcon

  return (
    <Button
      className="flex_space_between flex__align_center p-16 w-100"
      disabled={isDisabled}
      size={'large'}
      onClick={() => onClick(month)}
      onPointerEnter={() => setShowEditIcon(true)}
      onPointerLeave={() => setShowEditIcon(false)}
    >
      <div className="text-semi-bold">{month.monthName}</div>
      {!month.isFutureMonth && !canEdit && showIcon(month)}
      {canEdit && <Icon type="fas fa-pencil-alt" />}
    </Button>
  )
}

export default CoverageAttestationCalendarButton
